export default __webpack_public_path__ + "static/media/prev-E1A-SIDE-VIEW-2.1ee8ae0c.png";